import { AuthOption, NextPagePayloadInfo } from "../../config/types";
import CardHeader from "../../flow/shared/CardHeader";
import MergeLinkCardBase from "../../flow/shared/MergeLinkCardBase";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";
import ConnectorAuthChoiceButton from "./IntegrationAuthChoiceButton";
import ConnectorSetupStepFormHeader from "./connector-setup/ConnectorSetupStepFormHeader";

type Props = {
  linkingFlowPayload: NextPagePayloadInfo;
};

const IntegrationAuthChoiceScreen = ({ linkingFlowPayload }: Props) => {
  // derived state
  const connector = linkingFlowPayload.connector!;
  const authOptions = connector.auth_options;

  // hooks
  const {
    getNextPageAndSetPage,
    allowNavigateToPreviousEntryInHistory,
    navigateToPreviousEntryInHistory,
    onExit,
    translate,
  } = useAgentHandlerLinkModalContext();

  // event handlers
  const onSelectPath = (authOption: AuthOption) => {
    getNextPageAndSetPage({
      selected_connector: connector,
      selected_auth_option: authOption,
    });
  };

  return (
    <MergeLinkCardBase>
      <CardHeader
        onBack={
          allowNavigateToPreviousEntryInHistory ? navigateToPreviousEntryInHistory : undefined
        }
        onExit={onExit}
      />
      <ConnectorSetupStepFormHeader
        connector={connector}
        header={translate("authentication-title-question", "How would you like to authenticate?")}
      />
      <div className="flex flex-col px-5 grow justify-start gap-y-3">
        {/* AuthChoiceButtons */}
        {authOptions.map((authOption) => (
          <ConnectorAuthChoiceButton
            key={authOption.name}
            authOption={authOption}
            onClick={() => onSelectPath(authOption)}
          />
        ))}
      </div>
    </MergeLinkCardBase>
  );
};

export default IntegrationAuthChoiceScreen;
